import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Imprint from './pages/Imprint';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Privacy from './pages/Privacy';
import Checkout from './pages/Checkout';
import DracoChessPrivacy from './pages/DracoChessPrivacy';
import DracoChessSupport from './pages/DracoChessSupport';
import DracoGermanPrivacy from './pages/DracoGermanPrivacy';
import DracoGermanSupport from './pages/DracoGermanSupport';
import DracoGermanTerms from './pages/DracoGermanTerms';
import './App.css';

// 路由表：浏览器里包在 BrowserRouter 里，预渲染（src/entry-server.tsx）包在 StaticRouter 里
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/imprint" element={<Imprint />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/dracochess/privacy" element={<DracoChessPrivacy />} />
      <Route path="/dracochess/support" element={<DracoChessSupport />} />
      <Route path="/dracogerman/privacy" element={<DracoGermanPrivacy />} />
      <Route path="/dracogerman/support" element={<DracoGermanSupport />} />
      <Route path="/dracogerman/terms" element={<DracoGermanTerms />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
